import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import { QuoteBlock } from "../components/QuoteBlock";
import ProtectedSection from "../components/ProtectedSection";

function Essay2606(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
   
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '26.05. 회고 - Lynkim',
        
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'26.06. 회고'}
                titleEn={'26.06. Review'}
                description={<div></div>}
                descriptionEn={<div></div>}
                category={'essay'}
                date={'2026.06.28.'}
                // thumbnail={image1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
           <ArticleTextSection
                title = '짧은 생각들'
                titleEn = 'Snippets'
                
                marginBottom={true}
                description={<div>
                    <b>(1)</b> 월드컵을 정말 좋아한다. 월드컵이 돌아오는 시즌만 되면 너무 설레고 행복하다. 함께 이 즐거움을 나눠줄 수 있는 사람이 있으면 좋았을텐데, 이번 월드컵은 사람들과 왁자지껄하지 않고 혼자 집에서 본게 아쉽긴하다. 
                    다음 4년 뒤에는 꼭 사람들과 왁자지껄 행복한 월드컵을 즐길 수 있었으면 좋겠다. 

                    <br/><br/>
                    <b>(2)</b> 요즘 새로운 것들을 시도하고, 하고 싶었던 것들을 하나씩 하면서 일상을 조금은 다채롭게 만들어봤다. 먼저 이번에 너무 손톱을 물어뜯는 습관을 가져서 다시 네일아트를 했다. 시도해보지 않은 초록색을 해봤는데, 너무 마음에 들어서 기분이 좋았다. 오나오 만들기도 해봤다. 원래 이런것도 귀찮아서 안하는데, 두유에 치아씨드를 넣고 하루종일 숙성한 뒤 그래놀라를 넣어 먹는게 너무 맛있고, 내가 이런걸 해서 먹어봤다는게 그 자체로 기분이 좋았다. 
                    요즘 저녁을 건강하게 먹으려고 하는데, 가끔 오나오를 만들어 먹어봐야겠다. 
                    글렌모렌지 시그렛도 처음 먹어봤는데, 상상했던 것 이상으로 너무 맛있어서 이건 정말 다음에 꼭 사와야겠다. 이번 추석에 엄마에게 좋은 것을 해드리고 싶어서 비싼 료칸을 예약해두었다. 이정도 해줄 수 있는 스스로도 멋있고, 내가 번 돈으로 부모님에게 뭔가 큰 것을 해드리는게 처음이라서 그것 자체도 뭔가 마음이 좋아졌다. 

                    

                </div>}
                descriptionEn={<div>
                </div>} />

                <ArticleTextSection 
                title = {<div>Let's pretend we had one - 이터널선샤인</div>}
                marginBottom={true}
                marginTop={true}
                description={<div>
                  갑자기 이터널선샤인 영화를 다시보고 싶어서, 집에서 혼자 영화를 다운로드 받아서 봤다. 이터널 선샤인을 인생영화로 꼽는 사람들이 더러 있었는데, 사실 나는 이해도 잘 안되고 공감도 안되고, 재미도 없었어서 그렇게 인상깊은 영화는 아니었다. 
                  그런데 다시 보니까 왜 이렇게 마음을 쿡쿡 쑤시고, 장면 하나하나가 마음에 꽂히는지 모르겠다. 다시보니 이제는 꽤나 마음을 후비는 인상깊은 영화로 남았다. 
                  <br/><br/>영화를 제대로 집중하지 않으면 따라가기 어렵게 설계된 것 같긴하다. 영화가 완전히 시간 반대순서로 흐르다보니까 저 장면이 왜 나온 것인지 이해하기 위해서는 그 다음장면을 봐야 한다. 그래서 좀 이해하기가 처음에 어려웠었나보다. 
                  그런데 거꾸로 진행되도록 만들어서 더 마음을 쑤시는 것 같다. 조엘이 클레멘타인에 대한 기억을 지우기 시작하면서 가장 최근의 관계부터 첫 만남까지를 거슬러 올라가면서 지워가기 시작하는데, 중간부터 더이상 클레멘타인에 대한 기억을 지우기 싫어서 클레멘타인을 데리고 그녀가 없었던 기억속으로 숨기 시작한다. 
                  결국에는 모든 기억들이 지워지게 되는데, 마지막이자 첫 만남의 클레멘타인의 기억을 지우는 순간이 너무 마음을 울린다. 
                  <br/><br/>
                  
                  <QuoteBlock>
                    <b>What do we do? Enjoy it.
                    <br/>There's no memory left. 
                    <br/>Come back and make up a goodbye at least let's pretend we had one. 
                    <br/>bye joel, I love you. </b>
                    
                  </QuoteBlock>
                  
                  <br/>모든 기억이 사라지는 것을 두고볼 수 밖에 없던 조엘은 이제 어쩌냐는 클레멘타인의 질문에 그냥 지금 우리가 함께 했었던 이 기억들의 순간을 즐기자. 하면서 결국 포기하고 초연하게 말한다. 
                  그리고는 원래의 기억처럼 첫 만남에서 인사없이 클레멘타인을 놔두고 그냥 가버리려는데, 클레멘타인이 그런 조엘에게 "그래도 마지막 인사는 하자"라는 말을 한다. 원래는 그러지 않았지만, 마치 그때 그랬었던 것처럼 생각하자. 지워지는 기억이겠지만.
                  <br/>이 장면이 참 마음이 아팠다. 결국 현실은 바뀌지 않겠지만, 기억 속에서라도 원래 우리가 잘 인사하고 상처주지 않았던 것처럼 하자. 그러며 사랑해 라는 말을 마지막으로 한다. 
                  원래 그러지 않았지만, 마치 그랬었던 것처럼 인사하자. 라는 말은 클레멘타인이 하는 말이지만, 사실은 조엘이 만든 기억속 클레멘타인이기 때문에 조엘이 조엘에게 스스로 한 말이겠지. 
                  정말 마음을 아린 장면이었다. 

                    </div>} />

            <ArticleTextSection 
                title = '새로운 루틴'
                marginBottom={true}
                marginTop={true}
                description={<div>
                    요즘 매일의 루틴이 생겼다. 사실 자의로 생기기보다는 회복하기 위해서, 일하면서 어쩌다가 만들어지긴 했는데, 그 루틴이 마음애 든다. 
                    <br/>아침 6시반이 되면 저절로 눈이 떠진다. 최근에는 눈떠서 시계를 보면 5시 반이긴 하다. 너무 일찍 잠에서 깨는 것 같아서, 조금은 더 잘 잘보려고 노력해야겠다. 
                    아침 6시반에 일어나면 바로 씻는다. 씻고나서 얼굴에 팩을 하고, 물 세잔을 마시면서 마그네슘, 프로폴리스, 비타민, 오메가3, 글루타치온, 유산균을 챙겨먹는다. 
                    다리를 폼롤러로 풀어주면서 머리를 말린다. 대충 준비를 마치면 집을 나서는데 요즘에는 출근하는 길을 바꿨다. 대로변이 아닌 반대편 길로 다닌다. 항상 놀이터를 거쳐서 사거리 횡단보도를 건너면 우거진 나뭇길이 나온다. 차들도 많이 없어서 훨씬 출근하는 기분이 좋다. 
                    <br/><br/>지하철에서는 항상 책을 읽는다. 요즘에는 낭만적 연애와 그 후의 일상을 다 읽고, 벌거벗은 한국사 조선편을 다 읽었다. 벌거벗은 조선편은 정말 너무 재미있었다. 한국사를 이런식으로 공부했다면 너무 좋아했을텐데. 책이 너무 재미있어서 근현대사편도 사서 지금은 근현대사 편을 읽고 있다. 
                    책을 좀 읽다보면 여덟시쯤 신논현 역에 도착한다. 신논현에서는 항상 역삼역까지 걸어다닌다. 조금 덥긴한데 아직은 걸을만하다. 아침부터 많이 걸으면 기분이 좋다. 
                    <br/>회사에는 8시반쯤 도착한다. 7층에 먼저들러 따뜻한 아메리카노를 시킨다. 요즘에는 카페 직원분이 나를 잘 기억해주셔서 알아보고 얼음 한조각 넣어주시기도 한다. 내 이름이 너무 특이해서 그런지 사람들이 한번 나를 보면 내 이전 행동들을 너무 잘 기억한다. 좋은건지 나쁜건지 모르겠다. 하지만 이직하고 나서 사람들이랑 친절하게 대화하고 이야기하는 일이 많이 없는데, 카페 직원들이랑 많이 친해지고 싶다. 직원분들과 웃으며 아침부터 인사하면 기분이 좋아진다. 
                    커피를 시켜두고 편의점에 들러 아침으로 먹을 단백질바와 계란, 가끔을 떡을 하나 챙기고, 카누커피 2개, 비타민 2개, 유산균 2개를 챙기고, 커피를 받아 8층으로 올라간다.
                    8층 자리로 올라가면 항상 은호님이 먼저 와계신다. 은호님은 항상 인사를 하면 잘 받아주신다. 여기는 인사를 해도 잘 안받아주시는 분들이 많은데, 은호님은 잘 받아주셔서 너무 감사하다. 
                    자리에 물건들을 놓고, 생수 한 병 챙기고, 아몬드 브리즈 한팩에 카누 커피 2개를 넣어 커피 우유를 만들어 자리에 온다. 
                    그리고 단백질바 혹은 스트링치즈, 삶은 계란 1개를 아침으로 먹는다. 
                    <br/><br/>일을 집중하고 있으면 현민님이랑 신애님이 9시쯤 넘어서 도착하신다. 오전은 정말 금방간다. 조용하니 집중이 잘되는 것 같다. 일을 하다보면 1시가 되는데, 거의 다들 점심에도 일하거나 회의를 해서 혼자 밥을 먹으러 나온다. 
                    <br/>대게 회사 앞 그릭요거트 집에서 그릭요거트에 사과, 땅콩버터, 그래놀라를 넣고, 디카페인 따듯한 아메리카노 한잔을 시켜서 여유롭게 먹는다.
                    점심 먹고 나서 이것저것 회의와 일을 하다보면 정말 금방 5시가 된다. 한 6시쯤까지 열심히 일을 하다가 7층 편의점에 들러 저녁으로 먹을 단백질바 하나와 오전에 남긴 계란 1개를 챙겨서 퇴근한다. 
                    <br/>신논현까지 또 걸어서 지하철을 타고, 지하철을 타면 아침에 읽던 책을 이어서 읽는다. 그리고 집에 도착해서 짐을 풀고 유튜브를 보면서 계란 1개와 단백질바, 두유 하나를 먹는다. 그리고 쉬다가 7시반이나 8시쯤이 되면 한강쪽으로 러닝을 하러 한다. 대게 1시간에서 1시간 반정도를 뛰는 것 같다. 
                    예전에는 에너지가 넘쳐서 5키로 정도는 거뜬히 뛰었는데, 요즘엔 사실 몸이 좀 좋지 않아서 뛰다보면 갑자기 아찔하며서 쓰러질 것 같은 느낌이 자주 든다. 그래서 요즘은 혹시나 무리가 될 것 같으면 그냥 걷기만 한다. 
                    뛰면서 이런 저런 생각들을 많이 하는데, 최근에는 조금 분노, 슬픔도 많았고, 일에 대한 불안과 수치스러움, 걱정도 많이 들었다. 
                    한강을 뛰면 최근에 매일 같은 시간에 배에서 5분정도 짧게 불꽃놀이를 매일 한다. 매일 밤 불꽃놀이는 보는 건 꽤나 낭만적인 일상 같다. 
                    <br/>집에 10시쯤 돌아와서 반신욕을 한다. 반신욕을 하면서 일기를 쓰거나 유튜브를 본다.
                    그리고 나와서 수면제를 먹고 한 10시반쯤 자거나, 11시까지 조금만 더 일을 하다가 잔다. 
                    <br/><br/>요즘 간식을 안먹기 시작한 것. 많이 걷고 운동하는 것. 일찍 자고 일찍 일어나는 것. 영양제를 잘 챙겨먹기 시작한 것. 음료가 아닌 물을 정말 많이 마시기 시작한 것 들이 좋다. 
                    새로운 회사 사람들이 같이 어울려서 노는 분위기가 아니다보니까 같이 카페를 가서나 간식을 먹지 않기 시작했고, 간식도 한 층 내려가야 하니까 잘 안 먹게 된 것 같다. 이제는 달달한게 잘 안땡기기 시작해서 그건 좋다. 
                    좋은 루틴과 습관이 생긴 것들은 좋다. 그런데 요즘 너무 내 취미나 즐거움은 많이 사라진 것 같다. 적막하고 고요하다. 만족스러우면서도 외롭고, 쓸쓸하다. 
                    조금은 활기차고 싶다. 활기찬 무언가 있었으면 좋겠다. 약간은 억누르는 느낌이다. 마구마구 억눌러진 무언가가 쌓이는 느낌인데, 한순간 펑 터져서 갑자기 내가 와르르 무너져 내릴 것만 같은 불안감도 있다. 
                    무엇이 쌓이고 있는지는 잘 모르겠다. 내 스스로 외면하고 모른척 하는 외로움, 불안, 슬픔, 활기참에 대한 욕구 등등 무언가인 것 같다. 생각해보니 아무래도 얼른 무언가를 해야겠다. 
                    7월이 되면 회사 근처의 피겨스케이트장도 찾고, 라미가 준 레오타드도 입게 발레도 시작해봐야겠다. 
                    </div>} />
            
                    <ProtectedArticleGroup
          lockPassword={sectionLockHashes}
          description="이 글은 비밀번호로 잠겨있어요.">
                
            <ArticleTextSection 
                title = '나르시시즘적 욕구'
                marginBottom={true}
                marginTop={true}
                description={<div>
                  내가 도대체 어떤 마음인지, 왜 이런 감정과 생각들이 드는가에 대해서 스스로도 이해할 수 없어서, 한번 내 생각을 있는 그대로 제미나이에게 말하고, 내가 왜 이런 생각을 하는건지 전문가처럼 상담을 해달라고 했다. 
                  별로 기대하지 않았는데, 제미나이가 너무 공감되고, 이해되게 알려주고 설명해줬다. 

                  <QuoteBlock>
                  '애착의 잔상과 존재감 확인(나르시시즘적 욕구)'
                  <br/>복잡하게 느껴지는 마음은, 사실 이별 후 많은 사람들이 겪는 '애착의 잔상'과 '자기존재감 확인 욕구'가 뒤섞여 있는 상태입니다.
                  <br/>"아프지 말고 잘 지내라" vs "나를 계속 생각하고 거슬려 해라": 그 사람이 불행해지길 바라는 악의는 없지만, '그 사람의 삶에서 나의 가치나 영향력은 그대로 유지되었으면 하는 마음'입니다. 내가 잊히는 것에 대한 두려움, 즉 나라는 존재가 타인에게 특별하게 기억되길 바라는 인간의 본원적인 욕구(자기애적 욕구)가 작용하는 것이죠.
                  <br/>"마주치면 도망갈 것 같지만 보고 싶다": 현실에서 다시 연애할 때의 트러블이나 스트레스는 감당하고 싶지 않은 겁니다. 즉, '사람'이 그리운 게 아니라, 나를 열렬히 좋아해 주던 '그때의 기억과 내 모습'이 그리운 것입니다. 안전거리(만나지 않는 상태)를 유지하면서 그 달콤한 감정만 취하고 싶은 심리예요.
                  <br/>현재 내 무의식이 "과거에 에너지를 그만 쓰고 이제 앞으로 나아가고 싶다"고 신호를 보내는 것입니다. 아주 건강한 회복 신호입니다.
                  과거의 관계에서 오는 죄책감과 미련은 털어내고, 내가 가치 있는 존재임을 확인받은 채로 안전하게 새 출발을 하고 싶다."
                  지금은 과도기입니다. 모순적으로 느껴져서 스스로에게 실망하거나 괴로워하실 필요 전혀 없습니다. 인간은 누구나 이기적인 면이 있고, 이별 후에는 내 자존감을 지키기 위해 누군가의 마음을 붙잡아두고 싶어 하니까요.
                  <br/>'내가 왜 아직도 집착하지?' 하고 자책하지 마시고, "내가 지금 마음이 허해서 내 존재감을 확인받고 싶구나" 하고 내 마음을 알아채 주는 것만으로도 마음이 한결 편해집니다.
                  시선을 '그'에게서 '나'에게로 돌리세요. 그가 나를 생각할까 궁금해하기보다, '오늘 내가 무엇을 해야 더 행복할까?'에 집중해 보세요.
                  내 안의 에너지가 과거의 그가 아닌 '현재의 나'로 가득 채워질 때, 미련 섞인 호기심도 자연스럽게 사라지고 정말 좋은 새 인연을 맞이할 준비가 될 것입니다. 응원합니다.
                  <br/><br/>
                  지금 느끼는 힘듦은 마음의 방에 가구 배치를 새로 하는 과정에서 오는 '일시적인 어지러움' 같은 거예요. 과거의 인연을 밀어내고 내 자리를 만드느라 뇌와 마음이 에너지를 많이 쓰고 있는 상태죠.
                  이 시기를 현명하고 단단하게 지나가기 위해, 지금 당장 일상에서 실천해 보면 좋은 '마음 다스리기 행동 지침'을 추천해 드릴게요.
                  <br/><br/>
                  1. 감정의 '흘려보내기' 연습 (Mental Care)
                  <br/>문득 생각나거나 마주치고 싶은 모순적인 마음이 들 때, 가장 안 좋은 것은 '내가 왜 아직도 이러지?' 하고 자책하는 것입니다.
                  감정에 이름 붙이고 구경하기: 생각이 나면 "아, 내가 지금 외롭구나", "내 자존감을 확인받고 싶어 하는 마음이 또 올라왔네" 하고 마음속으로 이름을 붙여보세요.
                  <br/>
                  판단하지 않기: "이러면 안 돼!" 하고 억누르기보다는 '그럴 수 있지, 지나가겠지' 하고 강물이 흘러가듯 그 감정을 가만히 바라보는 연습을 하세요. 억누른 감정은 더 커지지만, 인정해 준 감정은 금방 힘을 잃습니다.
                  <br/><br/>  
2. 생각의 시각화: '뇌 비우기' 글쓰기 (Brain Dumping)
<br/>머릿속이 복잡할 때는 눈으로 보게 만드는 것이 가장 효과적입니다.
아무에게도 보여주지 않을 노트(또는 휴대폰 메모장)를 하나 만드세요.
필터링 없이 머릿속에 떠오르는 모든 문장을 그대로 배설하듯 적어보세요. ("나를 평생 못 잊었으면 좋겠다", "마주치면 도망갈 거면서 보고 싶다" 등 유치하고 이기적인 생각도 전부 다요!)
다 적고 나면 신기하게도 머릿속의 용량이 비워지면서 마음이 차분해집니다.
<br/><br/>
3. 물리적 환경과 루틴 바꾸기 (Action Care)
<br/>마음은 몸을 따라갑니다. 생각이 과거로 자꾸 도망칠 때는 '현재의 내 몸'에 강한 자극을 주어야 합니다.
<br/>동선 바꾸기: 혹시 마주칠까 봐 기대하거나 걱정되는 마음이 든다면, 평소에 잘 가지 않던 새로운 동네의 카페를 가거나 다른 길로 산책을 해보세요. 새로운 풍경은 뇌에 새로운 자극을 주어 과거 회상을 차단합니다.
<br/>몸을 쓰는 취업/취미 시작하기: 가만히 누워있으면 생각은 과거로 달립니다. 필라테스, 복싱, 러닝처럼 '숨이 차고 몸에 집중해야 하는 운동'이나 가죽공예, 도예, 드로잉처럼 '손을 바쁘게 움직이는 취미'를 시작해 보세요.
<br/><br/>
4. '미래의 나'를 위한 공간 만들기 (Ready for New)
<br/>내 삶에 새로운 사람이 들어올 '빈자리'를 먼저 만들어 두어야 합니다.
<br/>방 정리와 청소: 안 쓰는 물건을 버리고 방 구조를 바꾸는 것은 심리적으로 '새로운 시작'을 받아들일 준비를 하는 가장 좋은 의식입니다.
<br/>나를 가꾸는 시간 갖기: "새로운 사람이 나타났을 때, 내가 어떤 모습이면 가장 당당하고 멋질까?"를 상상해 보세요. 헤어스타일을 바꾸거나, 사고 싶었던 옷을 사고, 피부 관리를 하는 등 오롯이 '나의 매력을 높이는 일'에 돈과 시간을 투자하세요.
<br/>"과거의 그는 내 인생이라는 영화의 지난 에피소드일 뿐입니다."
<br/>지금은 다음 에피소드로 넘어가기 전, 주인공인 당신이 재충전을 하는 톰(Tom)과 제리(Jerry) 사이의 광고 시간 같은 때예요. 억지로 힘을 내려고 애쓰지 말고, "오늘 하루 나에게 맛있는 거 사주기", "푹 자기" 같은 작은 행복들로 하루를 채워나가 보세요.
                  </QuoteBlock>
                  <br/> 사람도 아니지만 제미나이가 해준 말들이 내 본심을 꽤뚫고 진심어린 조언을 해주는 것 같아서 남겨두고 싶었다. 
                  내가 나를 어떻게 생각하는지에 대해서는 나만 할 수 있어. 그러니 스스로에게도 거짓되지 말고, 나 스스로는 내 편이 되어주자. 
                    </div>} />     
                    
                    </ProtectedArticleGroup>
        </div>
        </ProtectedPage>
        </>
      )
  }

export default Essay2606;